import { URLS } from '~/assets/js/constants';

function getPath(params) {
  switch (params) {
    case 'manual':
      return URLS.manual_enem_url;
      break;
    case 'gabarito':
      return URLS.gabarito_url;
      break;
    default:
      break;
  }
}

export function getSubMenuUrls(activePage = '') {
  return [
    {
      name: 'Manual',
      path: getPath('manual'),
      active: activePage.includes('manual'),
    },
    {
      name: 'Gabarito',
      path: getPath('gabarito'),
      active: activePage.includes('gabarito'),
    },
  ];
}

export function getSubMenuAllLinks(activePage = '', category = '', lesson = '') {
  switch (activePage) {
    case 'manual':
      return [
        {
          name: 'Home',
          url: '',
          current: false
        },
        {
          name: 'Manual do Enem',
          url: getPath('manual'),
          current: true
        },
      ]
      break;
    case 'gabarito':
      return [
        {
          name: 'Home',
          url: '',
          current: false
        },
        {
          name: 'Manual do Enem',
          url: getPath('manual'),
          current: false
        },
        {
          name: 'Gabarito do Enem',
          url: getPath('gabarito'),
          current: true
        },
      ]
      break;
    case 'category':
      const { name } = category;

      return [
        {
          name: 'Home',
          url: '',
          current: false
        },
        {
          name: 'Manual do Enem',
          url: getPath('manual'),
          current: false
        },
        {
          name: name,
          url: '',
          current: true
        },
      ]
      break;
    case 'lesson':
      const { title } = lesson;

      return [
        {
          name: 'Home',
          url: '',
          current: false
        },
        {
          name: 'Manual do Enem',
          url: getPath('manual'),
          current: false
        },
        {
          name: lesson.category.name,
          url: `/enem/${lesson.category.slug}`,
          current: false
        },
        {
          name: title,
          url: '',
          current: true
        },
      ]
      break;
    default:
      break;
  }
}
